const internalMaterial = () =>
  import(
    /* webpackChunkName: "internalMaterial" */ "@/components/ssp/missions/mission/mission-preparation/InternalMaterial.vue"
  );

const externalMaterial = () =>
  import(
    /* webpackChunkName: "externalMaterial" */ "@/components/ssp/missions/mission/mission-preparation/ExternalMaterial.vue"
  );

const analysisPreparation = () =>
  import(
    /* webpackChunkName: "AnalysisPreparation" */ "@/components/ssp/missions/mission/mission-preparation/AnalysisPreparation.vue"
  );

const securingDrilling = () =>
  import(
    /* webpackChunkName: "SecuringDrilling" */ "@/components/ssp/missions/mission/mission-preparation/SecuringDrilling.vue"
  );

export default [
  {
    path: "",
    name: "internalMaterial",
    component: internalMaterial,
    meta: {
      showSubNavBar: true,
    },
  },
  {
    path: "external-material",
    name: "externalMaterial",
    component: externalMaterial,
    meta: {
      showSubNavBar: true,
    },
  },
  {
    path: "analysis-preparation",
    name: "analysisPreparation",
    component: analysisPreparation,
    meta: {
      showSubNavBar: true,
    },
  },
  {
    path: "securing-drilling",
    name: "securingDrilling",
    component: securingDrilling,
    meta: {
      showSubNavBar: true,
    },
  },
];
